import React from 'react';
import { TaskStatus } from '../types';
import type { Todo } from '../types';
import type { FormData } from '../utils/formUtils';
import { TaskCompletionHelper } from './TaskCompletionHelper';

interface TodoFormStatusRowProps {
  formData: FormData;
  setFormData: React.Dispatch<React.SetStateAction<FormData>>;
  todo?: Todo;
  onStartPomodoro?: (todo: Todo) => void;
}

const TodoFormStatusRow: React.FC<TodoFormStatusRowProps> = ({
  formData,
  setFormData,
  todo,
  onStartPomodoro,
}) => {
  return (
    <div className="flex items-center gap-6">
      {/* Status dropdown */}
      <div className="flex items-center gap-2">
        <span className="text-xs font-medium text-gray-600">Status:</span>
        <select
          value={formData.status}
          onChange={(e) => setFormData({ ...formData, status: e.target.value as TaskStatus })}
          className="text-xs px-3 py-1 pr-6 rounded-full border border-gray-300 font-medium cursor-pointer focus:ring-2 focus:ring-blue-500 bg-blue-50 text-blue-800 min-w-[100px]"
        >
          {[
            TaskStatus.NOT_STARTED,
            TaskStatus.IN_PROGRESS,
            TaskStatus.WAITING,
            TaskStatus.CANCELED,
            TaskStatus.COMPLETED,
          ].map(status => (
            <option key={status} value={status}>
              {status.replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase())}
            </option>
          ))}
        </select>
      </div>

      {/* Task Completion Helper - Only show for existing todos */}
      {todo && (
        <div className="flex items-center">
          <TaskCompletionHelper
            todo={todo}
            onStartPomodoro={onStartPomodoro}
          />
        </div>
      )}
    </div>
  );
};

export default TodoFormStatusRow;
